import React, { useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Autocomplete, TextField, InputAdornment, MenuItem } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

const CreateModal = ({ handleRefresh, apps }) => {
  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [selectedApp, setSelectedApp] = useState(null)
  const [categoryType, setCategoryType] = useState('') // State for category type

  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
    setSelectedApp(null)
    setProcessing(false)
    setCategoryType('') // Reset category type on close

  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const payload = {
      app_id: apps?.app_id,
      name: e.target.name.value,
      app_name: apps?.name,
      type: categoryType, // Add category type to payload
    }

    console.log(payload, 'payload')


    const { response } = await AppService.AppsOnboarding.create_category({ payload })

    if (response) {
      setProcessing(false)
      closeAddProduct()
      handleRefresh()
    } else {
      setProcessing(false)
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>

      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Onboarding Category
            </MDTypography>



            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput
                label="Name"
                name="name"
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <TextField
                select
                label="Select Type"
                value={categoryType}
                onChange={(e) => setCategoryType(e.target.value)}
                fullWidth
              >
                <MenuItem value="agency">Agency</MenuItem>
                <MenuItem value="location">Location</MenuItem>
              </TextField>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                disabled={processing}
              >
                {processing ? 'Adding...' : 'Add'}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
